import React from "react"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Button } from "components"
import { showFoodSidebar } from "@redux"
import { movePreviousOrderToCartForEdit } from "utils"
import classes from "./OrderDetailsEditButton.module.scss"

const OrderDetailsEditButton = props => {
  const { order } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const history = useHistory()

  const handlePress = () => {
    movePreviousOrderToCartForEdit(
      order,
      order.tableNumber
    )

    history.push("/foods")

    const isInMobileView =
      window.innerWidth <= 991

    isInMobileView &&
      dispatch(
        showFoodSidebar()
      )
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Button
      color="warning"
      fullWidth
      onClick={handlePress}
      className={clsx(
        classes["container"],
        isLtr && classes["container-ltr"]
      )}
    >
      {t("ویرایش")}
    </Button>
  )
}

export default OrderDetailsEditButton